import axios from 'axios';
import { showGlobalToast } from '../utils/toast';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:8000',
});

// Getter function set by AuthContext — reads from a ref so it's always current
let tokenGetter: () => string | null = () => null;

export function setTokenGetter(getter: () => string | null): void {
  tokenGetter = getter;
}

// Callback invoked by the 401 interceptor so AuthContext can clear state
let _onUnauthorized: (() => void) | null = null;

export function setUnauthorizedHandler(handler: () => void): void {
  _onUnauthorized = handler;
}

// ── Request interceptor — attach Bearer token ──────────────────────────────
apiClient.interceptors.request.use((config) => {
  const token = tokenGetter();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ── Response interceptor — handle 401 / 500 ───────────────────────────────
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      _onUnauthorized?.();
    } else if (status >= 500) {
      showGlobalToast('Something went wrong. Please try again.', 'error');
    }
    return Promise.reject(error);
  },
);

export default apiClient;
